var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:({ backgroundImage: 'url(' + _vm.currentBackground + ')' })},[_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('home.title')))]),_c('el-button',{attrs:{"round":"","plain":""},on:{"click":_vm.handleMore}},[_vm._v(_vm._s(_vm.$t('home.button')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }